export class WriteValueModalArgs {
    constructor(variableName, dataType, integerDigits, fractionDigits, numericalOperation, version) {
        this.variableName = variableName;
        this.dataType = dataType;
        this.integerDigits = integerDigits;
        this.fractionDigits = fractionDigits;
        this.numericalOperation = numericalOperation;
        this.version = version;
    }
}
